// ======================================================================
// File Name       : RegisterMessageThreadInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col, InputGroup, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import { MSG_NOT_ACCEPT_FILE } from '../../constants/MessageThreadContants';

class RegisterMessageThreadInfo extends React.Component {
  render() {
    const { fileSize, fileName, radioChange } = this.props;
    return (
      <div className="col-sm-12">
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            スレッドタイトル<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={8}>
            <RenderField
              type="text"
              name="messageTitle"
              label="スレッドタイトル"
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info label-middle">
          <Col as={Form.Label} sm={3}>
            スレッド詳細<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={8}>
            <RenderField
              type="textarea"
              name="messageContent"
              label="スレッド詳細"
              rows={7}
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>
            添付ファイル
          </Col>
          <Col sm={8}>
            <RenderField
              type="batchimport"
              name="attachmentFile"
              label="添付ファイル"
              validates={[VALIDATE_TYPE.DOCUMENT_SIZE, VALIDATE_TYPE.NOT_ACCEPT_FILE]}
              value={fileSize}
              fileName={fileName}
              fileSize={fileSize}
              notAccept={MSG_NOT_ACCEPT_FILE}
              accept={' '}
              fieldInput={8}
              fieldButton={2}
              showMessageErrorFullRows
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={10} className="margin-left-10">
            <RenderField
              type="checkbox"
              label="送信先ユーザーを指定しない"
              name="messageOperationFlag"
              radioChange={radioChange}
              checkRadioChange
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default RegisterMessageThreadInfo;
